import React from "react";
import { Outlet } from "react-router-dom";
//import Cookies from "js-cookie";
import Signup from "../auth/Signup";
import { AuthService } from "../../services/auth/authService";

const Register = () => {
  // const navigate = useNavigate();
  // const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <AuthService>
        <div className="md:px-6 sm:px-3 pt-4">
          <div className="container-fluid">
            <Signup />
            <Outlet />
          </div>
        </div>
      </AuthService>
    </>
  );
};

export default Register;
